(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PlannedShipmentDialogController', PlannedShipmentDialogController);

    PlannedShipmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PlannedShipment', 'Contract'];

    function PlannedShipmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PlannedShipment, Contract) {
        var vm = this;

        vm.plannedShipment = entity;
        vm.clear = clear;
        vm.save = save;
        vm.contracts = Contract.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.plannedShipment.id !== null) {
                PlannedShipment.update(vm.plannedShipment, onSaveSuccess, onSaveError);
            } else {
                PlannedShipment.save(vm.plannedShipment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccstrtest1App:plannedShipmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
